import React, { useEffect, useState } from 'react';
import { adminStaffService } from '../../services/adminStaffService';
import { toast } from 'react-toastify';
import { ChevronLeft, ChevronRight, RefreshCw } from 'lucide-react'; // 👉 ĐÃ THÊM: Icon RefreshCw

const AdminActionLogPage = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // State phân trang
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const pageSize = 20;

    useEffect(() => {
        fetchLogs(currentPage);
    }, [currentPage]);

    const fetchLogs = async (page) => {
        try {
            setLoading(true);
            const res = await adminStaffService.getActionLogs(page, pageSize);
            
            // Backend trả về đối tượng Page của Spring Boot
            const responseData = res?.data || res;
            setLogs(responseData.content || []);
            setTotalPages(responseData.totalPages || 0);
            setTotalElements(responseData.totalElements || 0);
            
        } catch (error) {
            toast.error("Không thể tải nhật ký hoạt động!");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const getActionColor = (actionType) => {
        switch (actionType) {
            case 'CREATE': return 'bg-green-100 text-green-800';
            case 'UPDATE': return 'bg-blue-100 text-blue-800';
            case 'DELETE': return 'bg-red-100 text-red-800';
            case 'LOGIN': return 'bg-gray-100 text-gray-800';
            default: return 'bg-purple-100 text-purple-800';
        }
    };

    // 👉 ĐÃ THÊM: Class font-inter để đồng bộ font chữ toàn trang
    return (
        <div className="font-inter p-6 bg-white rounded-lg shadow-md m-4 flex flex-col h-[calc(100vh-8rem)]">
            <div className="flex justify-between items-center mb-4 shrink-0">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Nhật ký hoạt động hệ thống</h1>
                    <p className="text-sm text-gray-500 mt-1">Tổng cộng: {totalElements} bản ghi</p>
                </div>
                
                {/* 👉 ĐÃ SỬA: Thay đổi màu nút và thêm Icon Làm mới */}
                <button 
                    onClick={() => fetchLogs(currentPage)} 
                    disabled={loading}
                    className="flex items-center gap-2 px-4 py-2 bg-tnc-orange text-white font-medium rounded hover:bg-tnc-orange-hover transition disabled:opacity-50"
                >
                    <RefreshCw size={18} className={loading ? "animate-spin" : ""} />
                    Làm mới
                </button>
            </div>

            {loading ? (
                <div className="flex-1 flex justify-center items-center text-gray-500 font-medium">Đang tải dữ liệu...</div>
            ) : (
                <>
                    <div className="flex-1 overflow-y-auto border rounded-lg scrollbar-thin">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50 sticky top-0 z-10">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Thời gian</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Người thực hiện</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Hành động</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Mô-đun</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Chi tiết</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {logs?.length > 0 ? logs.map((log) => (
                                    <tr key={log.logId} className="hover:bg-gray-50 transition-colors duration-150">
                                        <td className="px-4 py-3 text-sm font-semibold text-gray-700 whitespace-nowrap">
                                            {log.createdAt}
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                            <div className="font-bold text-gray-900">{log.accountName || 'Unknown'}</div>
                                            <div className="text-xs text-gray-500">{log.username}</div>
                                        </td>
                                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                                            <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${getActionColor(log.actionType)}`}>
                                                {log.actionType}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-600 font-medium">
                                            {log.targetEntity} <br/> 
                                            <span className="text-xs text-gray-400 font-normal">ID: {log.targetId || 'N/A'}</span>
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-800">
                                            {log.details}
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="5" className="px-4 py-8 text-center text-gray-500 font-medium">Chưa có nhật ký hoạt động nào.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Khung Phân Trang */}
                    <div className="flex items-center justify-between mt-4 pt-4 border-t shrink-0">
                        <span className="text-sm font-medium text-gray-600">
                            Trang <span className="font-bold text-gray-900">{totalPages > 0 ? currentPage + 1 : 0}</span> / {totalPages}
                        </span>
                        <div className="flex gap-2">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 0))}
                                disabled={currentPage === 0}
                                className="flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-tnc-orange disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                            >
                                <ChevronLeft size={16} /> Trước
                            </button>
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages - 1))}
                                disabled={currentPage >= totalPages - 1 || totalPages === 0}
                                className="flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-tnc-orange disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                            >
                                Sau <ChevronRight size={16} />
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AdminActionLogPage;